import React, { useEffect, useState, useRef } from "react"
import { useNavigate } from 'react-router-dom'
import {
  Button,
  Col,
  Input,
  Row,
} from "reactstrap"
import { Info } from "lucide-react"
import GatedMetric from "../../components/Common/GatedMetric"
//import PerformanceTable from "../additional_components/PerformanceTable"
import PerformanceDataTable from "../../additional_components/marketResearch/PerformanceDataTable"
import axios from "axios"
import { api } from "../../utils/variables"
import { buildKeywordSearchParams, KEYWORD_SEARCH_PATH, normalizeSearchGames } from "../../utils/keywordSearch"
import { apiService } from "../../utils/prefetchManager"
import { usePlatforms } from "../../contexts/PlatformsContext"
import PlatformTabs from "../../components/Common/PlatformTabs"
import { userProfileApi } from "../../services/userProfileApi"
import PublisherDataTable from "../../additional_components/marketResearch/PublisherDataTable"
import FilterPanel from "../../components/KeywordTrackingNewUIPage/FilterPanel"
import AppsTrackingPlanModal from "../../components/Common/Modal/AppsTrackingPlanModal"
import { useFilters } from "../../hooks/useFilters"
import { useOnboarding } from "../../contexts/OnboardingContext"
import SEO from "../../components/Common/SEO"
import { PAGE_SEO, STRUCTURED_DATA } from "../../config/seoConfig"
import { generateCanonicalUrl } from "../../utils/seoUtils"
import { useSearchProgress } from "../../hooks/useSearchProgress"
import SearchProgressModal from "../../components/Common/Modal/SearchProgressModal"
import { useAnalytics, ANALYTICS_EVENTS } from "../../analytics"

export default function PublisherAnalysis() {
  const { trackEvent } = useAnalytics()
  const { filterSections } = useFilters()
  const { getActivePlatforms, normalizePlatformName, getPlatformDisplayName, loading: platformsLoading } = usePlatforms()
  const navigate = useNavigate()
  const { onboardingState, markPageCompleted } = useOnboarding()
  const [searchValue, setsearchValue] = useState("")
  const [inputValue, setInputValue] = useState("")
  const [isLoadingResults, setIsLoadingResults] = useState(false)

  const [categoryApps, setcategoryApps] = useState([])
  const [filteredApps, setCatFilteredApps] = useState([])
  // Set default platform to first active platform from API
  const [selectedPlatform, changePlatform] = useState(() => {
    const activePlatforms = getActivePlatforms()
    return activePlatforms.length > 0 ? activePlatforms[0].id : "meta"
  })
  const [categoryData, setcategoryData] = useState([])
  const [dataAction, setDataAction] = useState("loading")
  const [searchType, setSearchType] = useState("publisher");
  const [predefCategory, setpredef] = useState([])
  const [predefPublishers, setPredefPublishers] = useState([])
  const [selectedChip, setSelectedChip] = useState(null)
  const [topPublishers, setTopPublishers] = useState([])
  const [isExplorerOnly, setIsExplorerOnly] = useState(false)
  const [showFilters, setShowFilters] = useState(false)
  const [publisherFiltersRaw, setPublisherFiltersRaw] = useState({})
  const [publisherApiFilters, setPublisherApiFilters] = useState({})
  const [restoredSearchFromSession, setRestoredSearchFromSession] = useState(false)
  const filterButtonRef = useRef(null)
  const searchButtonRef = useRef(null)
  const searchInputRef = useRef(null)
  const chipsSectionRef = useRef(null)
  // Ref to signal cancellation into the async fetch/poll loop
  const cancelRef = useRef(false)

  // Publisher autocomplete suggestions
  const [publisherSuggestions, setPublisherSuggestions] = useState([])
  const [showSuggestions, setShowSuggestions] = useState(false)
  const [suggestionsLoading, setSuggestionsLoading] = useState(false)
  const [highlightedSuggestion, setHighlightedSuggestion] = useState(-1)
  const suggestionsRef = useRef(null)
  const suggestDebounceRef = useRef(null)
  // Set to true when a publisher is confirmed (dropdown select / chip click) so the
  // suggestions useEffect doesn't re-open the dropdown immediately after selection.
  const justSelectedRef = useRef(false)
  const storedAppsData = sessionStorage.getItem("categoryApps")
  const catData = sessionStorage.getItem("categoryAppsData")

  const funFacts = [
    "In the early '90s, Virtuality introduced arcade VR systems. While the graphics weren’t great by today’s standards, it was a huge leap forward in immersive gaming.",
    "VR has been used for therapy, helping people confront their fears safely. Whether it's flying, heights, or spiders, VR lets you face your phobia in a controlled virtual environment.",
    "Games like Beat Saber and The Thrill of the Fight give you a great cardio workout. You’re not just sitting there—you’re actively moving and getting your heart rate up!",
    "Titles like BoxVR make exercise fun by turning it into a boxing simulation. You can burn calories while feeling like a badass in the process.",
    "NASA uses VR to help astronauts practice in space-like environments, simulating zero gravity, equipment repair, and mission procedures before they head off to the stars.",
    "Not just for gaming—apps like Bigscreen let you watch movies with friends in a virtual theater. It’s a totally immersive social experience.",
    "The first VR headsets were clunky and uncomfortable. The Virtual Boy, for example, was so heavy that it was hard to use for more than a short period!",
    "VR is used in mental health therapy, offering calming environments or stress-relieving experiences. It’s even being tested for things like anxiety and PTSD treatment.",
  ]

  const [randomFact, setRandomFact] = useState("")

  // Update default platform when platforms are loaded from API
  useEffect(() => {
    if (!platformsLoading) {
      const activePlatforms = getActivePlatforms()
      if (activePlatforms.length > 0 && !selectedPlatform) {
        changePlatform(activePlatforms[0].id)
      }
    }
  }, [platformsLoading, getActivePlatforms, selectedPlatform, changePlatform])

  useEffect(() => {
    fetchPredefinedCategory()
    fetchPredefinedPublishers()
    // also fetch top publishers so publisher-mode has data derived from Meta
    fetchTopPublishers()
    // determine whether current user is on Explorer (free) plan so we can blur premium metrics
    let cancelled = false
      ; (async () => {
        try {
          const res = await userProfileApi.fetchCurrentPlan()
          if (cancelled) return
          const hasProduct = !!(res && res.data && res.data.product)
          setIsExplorerOnly(!hasProduct)
        } catch (err) {
          console.error('Error fetching current plan for premium gating:', err)
          // assume not explorer-only to avoid hiding info for paid users in case of error
          setIsExplorerOnly(false)
        }
      })()
    if (storedAppsData) {
      //setInputValue(sessionStorage.getItem("searchedAppCA"))
      //setcategoryApps(JSON.parse(storedAppsData))
      //setcategoryData(JSON.parse(catData))
      //setCatFilteredApps(JSON.parse(storedAppsData))
      //setcategoryData(JSON.parse(storedcategoryData))
    }
  }, [])

  // Restore any persisted filters (persisted by handleApplyPublisherFilters)
  // Only restore when not in 'publisher' search mode. If in publisher mode,
  // clear the in-memory filters so badges don't show on initial load.
  useEffect(() => {
    try {
      if (searchType === 'publisher') {
        // Ensure no badges are shown when searching by publisher on first load
        setPublisherFiltersRaw({})
        setPublisherApiFilters({})
        return
      }

      const raw = sessionStorage.getItem('publisherAppliedFilters')
      const parsed = raw ? JSON.parse(raw) : null
      if (parsed && typeof parsed === 'object' && Object.keys(parsed).length) {
        setPublisherFiltersRaw(parsed)
        setPublisherApiFilters(parsed)
      }
    } catch (e) {
      // ignore JSON parse / storage errors
    }
  }, [searchType])

  // Publisher Explorer tutorial onboarding disabled:
  // previously we checked onboarding state and positioned highlight boxes dynamically.
  // That logic has been removed to keep the page free of tutorial overlays.

  // Restore last searched term + results from sessionStorage when user returns to page
  // Only restore when the last search type matches current `searchType` to avoid
  // showing keyword results in publisher mode unintentionally.
  useEffect(() => {
    try {
      if (restoredSearchFromSession) return
      const lastType = sessionStorage.getItem('publisherLastSearchType') || null
      if (!lastType || lastType !== searchType) return

      const lastTerm = sessionStorage.getItem('searchedAppCA')
      const rawApps = sessionStorage.getItem('categoryApps')
      const rawData = sessionStorage.getItem('categoryAppsData')
      if (lastTerm && rawApps) {
        const parsedApps = JSON.parse(rawApps)
        const parsedData = rawData ? JSON.parse(rawData) : []
        // restore input and states
        setInputValue(lastTerm)
        setsearchValue(lastTerm)
        setcategoryApps(parsedApps || [])
        setCatFilteredApps(Array.isArray(parsedApps) ? parsedApps.filter(g => g.platform === selectedPlatform) : [])
        setcategoryData(parsedData || [])
        setRestoredSearchFromSession(true)
      }
    } catch (e) {
      // ignore parse errors
    }
  }, [searchType, selectedPlatform, restoredSearchFromSession])

  // Filter data when platform or categoryApps changes
  useEffect(() => {
    // Always filter by a concrete platform; default is 'meta'
    const platformFilteredGames = Array.isArray(categoryApps)
      ? categoryApps.filter(game => game.platform === selectedPlatform)
      : []

    setCatFilteredApps(platformFilteredGames)
  }, [selectedPlatform, categoryApps])

  // Clear results when the input box is emptied by the user
  useEffect(() => {
    try {
      if (typeof inputValue === 'string' && inputValue.trim() === '') {
        // clear results and related UI state to avoid showing stale data
        setcategoryApps([])
        setCatFilteredApps([])
        setsearchValue("")
        setSelectedChip(null)
        setIsLoadingResults(false)
        // reset any summary/metadata so KPI cards (Average App Score etc.) return to empty/default
        setcategoryData([])
      }
    } catch (err) {
      console.error('Error clearing results on empty input:', err)
    }
  }, [inputValue])





  // Fetch publisher suggestions as user types (debounced 300 ms)
  useEffect(() => {
    if (searchType !== 'publisher') {
      setPublisherSuggestions([])
      setShowSuggestions(false)
      return
    }
    const query = inputValue?.trim()
    if (!query || query.length < 2) {
      setPublisherSuggestions([])
      setShowSuggestions(false)
      return
    }
    if (suggestDebounceRef.current) clearTimeout(suggestDebounceRef.current)
    suggestDebounceRef.current = setTimeout(async () => {
      if (justSelectedRef.current) {
        justSelectedRef.current = false
        return
      }
      setSuggestionsLoading(true)
      try {
        const res = await axios.get(`${api}/tracker/publishers/dropdown`, {
          params: { query, platform: selectedPlatform || '', limit: 20 },
          headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
        })
        const d = res.data
        const list = Array.isArray(d)
          ? d
          : (d?.results || d?.publishers || d?.data || [])
        setPublisherSuggestions(list)
        setHighlightedSuggestion(-1)
        setShowSuggestions(list.length > 0)
      } catch (e) {
        setPublisherSuggestions([])
        setShowSuggestions(false)
      } finally {
        setSuggestionsLoading(false)
      }
    }, 300)
    return () => { if (suggestDebounceRef.current) clearTimeout(suggestDebounceRef.current) }
  }, [inputValue, searchType, selectedPlatform])

  // Close suggestions when clicking outside the search field
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (suggestionsRef.current && !suggestionsRef.current.contains(e.target)) {
        setShowSuggestions(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const getSuggestionName = (item) =>
    typeof item === 'string' ? item : (item?.name || item?.publisher || item?.label || String(item))

  const handleSelectSuggestion = (item) => {
    const name = getSuggestionName(item)
    justSelectedRef.current = true
    setInputValue(name)
    setShowSuggestions(false)
    setPublisherSuggestions([])
    setHighlightedSuggestion(-1)
    setSelectedChip(null)
    setcategoryApps([])
    setCatFilteredApps([])
    setIsLoadingResults(true)
    fetchSearchResult(name)
    setsearchValue(name)
    try { sessionStorage.setItem('publisherLastSearchType', 'publisher') } catch (e) { }
  }

  const handleKeyDown = event => {
    if (showSuggestions && publisherSuggestions.length > 0) {
      if (event.key === 'ArrowDown') {
        event.preventDefault()
        setHighlightedSuggestion(prev => Math.min(prev + 1, publisherSuggestions.length - 1))
        return
      }
      if (event.key === 'ArrowUp') {
        event.preventDefault()
        setHighlightedSuggestion(prev => Math.max(prev - 1, -1))
        return
      }
      if (event.key === 'Escape') {
        setShowSuggestions(false)
        return
      }
      if (event.key === 'Enter' && highlightedSuggestion >= 0) {
        event.preventDefault()
        handleSelectSuggestion(publisherSuggestions[highlightedSuggestion])
        return
      }
    }
    if (event.key === "Enter") {
      handleSearch()
    }
  }

  const fetchTopPublishers = async () => {
    try {
      // Fetch trending apps for all active platforms dynamically
      const activePlatforms = getActivePlatforms();
      const platformPromises = activePlatforms.map(platform => 
        apiService.fetchTrendingByPlatform(platform.id)
      );
      
      const platformResults = await Promise.allSettled(platformPromises);
      
      // Combine all platform data
      const combined = platformResults.reduce((acc, result) => {
        if (result.status === 'fulfilled' && result.value?.games) {
          return [...acc, ...result.value.games];
        }
        return acc;
      }, []);

      // Count publishers
      const counts = combined.reduce((acc, game) => {
        const pub = (game.publisher || game.developer || game.publisher_name || '').trim()
        if (!pub) return acc
        acc[pub] = (acc[pub] || 0) + 1
        return acc
      }, {})

      // Convert to sorted array and pick top 5
      const top = Object.entries(counts)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 5)
        .map(([name]) => name)

      setTopPublishers(top)
    } catch (err) {
      console.error('Error fetching top publishers:', err)
      setTopPublishers([])
    }
  }

  const predefSearch = value => {
    justSelectedRef.current = true
    setInputValue(value)
    setSelectedChip(value)
    setIsLoadingResults(true)
    // clear previous results immediately to avoid stale UI while new request is in flight
    setcategoryApps([])
    setCatFilteredApps([])

    // Directly call fetchSearchResult instead of handleSearch to avoid any side effects
    fetchSearchResult(value)
    setsearchValue(value)
  }

  const fetchPredefinedCategory = () => {
    //https://api.triviumpro.in/predefined/category
    axios.get(`${api}/tracker/dashboard/trending_keywords`, {})
      .then(res => {
        // API responds with an object { message, data: [...], details, key }
        // we only care about the `data` array
        setpredef(res.data?.data || [])
      })
      .catch(error => {
        console.error("Error fetching predefined categories:", error)
        setpredef([]) // Set empty array as fallback
      })
  }

  const fetchPredefinedPublishers = () => {
    // Fetch predefined publishers to populate publisher chips
    axios.get(`${api}/tracker/predefined/publisher`, {})
      .then(res => {
        // API responds with { message, data: [...] }
        setPredefPublishers(res.data?.data || [])
      })
      .catch(error => {
        console.error("Error fetching predefined publishers:", error)
        setPredefPublishers([])
      })
  }
  // value: search term (keyword or publisher)
  // platformOverride: optional string to force platform for this request (''|'meta')
  // apiFiltersOverride: if provided (even as an empty object {}) use these filters instead of the state-held publisherApiFilters
  const fetchSearchResult = async (value, platformOverride = null, apiFiltersOverride = undefined) => {
    //setting input value
    sessionStorage.setItem("searchedAppCA", value)
    // Reset cancel flag and ensure loading is set when this helper is invoked directly
    cancelRef.current = false
    setIsLoadingResults(true)

    try {
      if (searchType === "publisher") {
        // callPublisherAPI(value);
        // merge query and any applied filters into params
        const params = { query: value }
        // determine platform to use: override if provided, otherwise current state
        const platformToUse = platformOverride !== null ? platformOverride : selectedPlatform
        // Use explicit platform value, default to empty string when falsy
        params.platform = platformToUse || ''
        // honor an explicit override (including an empty object) when provided, otherwise use state
        const effectiveFilters = apiFiltersOverride !== undefined ? apiFiltersOverride : publisherApiFilters
        if (effectiveFilters && Object.keys(effectiveFilters).length) {
          // include filter params; for array values join with comma+space to match other helpers
          Object.keys(effectiveFilters).forEach(k => {
            const v = effectiveFilters[k]
            if (v == null) return
            if (Array.isArray(v)) params[k] = v.join(', ')
            else params[k] = v
          })
        }

        if (process.env.NODE_ENV !== 'production') {
          try { console.debug('Publisher search params', params) } catch (e) { /* ignore */ }
        }
        let res = await axios.get(`${api}/tracker/publisher/search`, {
          params,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        })

        trackEvent(ANALYTICS_EVENTS.FEATURE.PUBLISHER_SEARCH, { publisher_name: value, platform: selectedPlatform })

        setDataAction("DISPLAY")
        //setDataAction(res.data.action)
        setCatFilteredApps(res.data.results)
        setcategoryApps(res.data.results)

        // Store summary/metadata returned by the publisher API so KPI cards can use it
        // many publisher endpoints include a `summary` object with aggregated fields
        if (res.data) {
          setcategoryData(res.data)
        }

        // while (res.data?.action?.toLowerCase() !== "display") {
        //   console.log("Waiting for action to become 'display'...")

        //   // Wait for 2 seconds before fetching again
        //   //await new Promise(resolve => setTimeout(resolve, 2000))

        //   // Fetch again to check the action
        //   //res = await axios.get(`${api}/tracker/category/${value}`, {})
        //   setDataAction("display")
        // }

        // Check if the 'games' object is not empty
        const games = res.data.results || [] // Default to empty array if undefined or empty
        //const games = res.data.games.games
        //setcategoryData(res.data.games)
        sessionStorage.setItem(
          "categoryAppsData",
          JSON.stringify(res.data.games)
        )

        setcategoryApps(games)
        // Store the games in sessionStorage (or an empty array if no games)
        sessionStorage.setItem("categoryApps", JSON.stringify(games))
        //sessionStorage.setItem("filteredApps", JSON.stringify(games))

        //store category data
        sessionStorage.setItem("categoryData", JSON.stringify(res.data.games))
        setIsLoadingResults(false)

        // const platformFilteredGames =
        //   selectedPlatform !== "all"
        //     ? res.data.games.filter(game => game.platform === selectedPlatform)
        //     : res.data.games
        // setCatFilteredApps(platformFilteredGames)
      } else {
        // callKeywordAPI(value);
        // We'll poll the keyword endpoint every 5s until the backend returns action === 'display'
        const pollIntervalMs = 5000
        const maxAttempts = 12 // ~1 minute cap to avoid infinite polling
        let attempts = 0

        const fetchOnce = async () => {
          try {
            // Build query params similar to apiService.fetchKeywordSearchResults
            const params = {}
            // include platform filter if selected; prefer override if provided
            const platformToUse = platformOverride !== null ? platformOverride : selectedPlatform
            params.platform = platformToUse || ''

            // honor an explicit override (including an empty object) when provided, otherwise use state
            const effectiveFilters = apiFiltersOverride !== undefined ? apiFiltersOverride : publisherApiFilters
            if (effectiveFilters && typeof effectiveFilters === 'object' && Object.keys(effectiveFilters).length) {
              Object.entries(effectiveFilters).forEach(([k, v]) => {
                if (v === undefined || v === null || v === '') return
                if (Array.isArray(v)) params[k] = v.join(', ')
                else params[k] = v
              })
            }

            const searchParams = buildKeywordSearchParams(value, params)
            const queryString = new URLSearchParams(searchParams).toString()
            const url = `${api}${KEYWORD_SEARCH_PATH}${queryString ? `?${queryString}` : ''}`

            const resp = await axios.get(url, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              },
            })

            return resp
          } catch (err) {
            throw err
          }
        }

        let res
        try {
          res = await fetchOnce()
          trackEvent(ANALYTICS_EVENTS.FEATURE.PUBLISHER_KEYWORD_SEARCH, { keyword: value })
        } catch (err) {
          console.error("Initial keyword fetch failed:", err)
          if (isUpgradeError(err)) {
            setShowUpgradeModal(true)
          }
          // clear stale results and stop loading
          setcategoryApps([])
          setCatFilteredApps([])
          setIsLoadingResults(false)
          return
        }

        // If initial response asks for upgrade, show modal and stop
        if (isUpgradeResponse(res.data)) {
          setShowUpgradeModal(true)
          setIsLoadingResults(false)
          return
        }

        // If backend hasn't finished, poll until it returns action === 'display'
        let action = (res.data?.action || "").toLowerCase()
        while (action !== "display" && attempts < maxAttempts) {
          // Check if cancelled by user
          if (cancelRef.current) {
            setcategoryApps([])
            setCatFilteredApps([])
            setIsLoadingResults(false)
            return
          }
          attempts += 1
          // show skeleton while waiting
          setIsLoadingResults(true)
          await new Promise(resolve => setTimeout(resolve, pollIntervalMs))
          try {
            res = await fetchOnce()
          } catch (err) {
            console.error("Polling keyword fetch failed:", err)
            if (isUpgradeError(err)) {
              setShowUpgradeModal(true)
            }
            // clear stale results and stop loading
            setcategoryApps([])
            setCatFilteredApps([])
            setIsLoadingResults(false)
            return
          }

          if (isUpgradeResponse(res.data)) {
            setShowUpgradeModal(true)
            setIsLoadingResults(false)
            return
          }

          action = (res.data?.action || "").toLowerCase()
        }

        if (action !== "display") {
          console.warn("Keyword polling stopped after max attempts without 'display' action")
          // Stop skeleton and show no-results state
          setcategoryApps([])
          setCatFilteredApps([])
          setIsLoadingResults(false)
          return
        }

        setDataAction("DISPLAY")
        //setDataAction(res.data.action)
        res.data.games = normalizeSearchGames(res.data.games)
        setCatFilteredApps(res.data.games)
        setcategoryApps(res.data.games)
        // while (res.data.action.toLowerCase() !== "display") {
        //   console.log("Waiting for action to become 'display'...")

        //   // Wait for 2 seconds before fetching again
        //   await new Promise(resolve => setTimeout(resolve, 2000))

        //   // Fetch again to check the action
        //   res = await axios.get(`${api}/tracker/category/${value}`, {})
        //   setDataAction(res.data.action)
        // }

        // Check if the 'games' object is not empty
        const games = res.data?.games || [] // Default to empty array if undefined or empty
        //const games = res.data.games.games
        setcategoryData(res.data.games)
        sessionStorage.setItem(
          "categoryAppsData",
          JSON.stringify(res.data.games)
        )

        setcategoryApps(games)
        // Store the games in sessionStorage (or an empty array if no games)
        sessionStorage.setItem("categoryApps", JSON.stringify(games))
        //sessionStorage.setItem("filteredApps", JSON.stringify(games))

        //store category data
        sessionStorage.setItem("categoryData", JSON.stringify(res.data.games))
        setIsLoadingResults(false)

        // const platformFilteredGames =
        //   selectedPlatform !== "all"
        //     ? res.data.games.filter(game => game.platform === selectedPlatform)
        //     : res.data.games
        // setCatFilteredApps(platformFilteredGames)
      }
      // Initial API call to get the action and details
    } catch (error) {
      console.error("Error fetching data:", error)
      // If backend returns upgrade info inside an error response, show modal
      if (isUpgradeError(error)) {
        setShowUpgradeModal(true)
      }
      // Clear any stale results when an error occurs
      setcategoryApps([])
      setCatFilteredApps([])
      setIsLoadingResults(false)
    }
  }

  const handleApplyPublisherFilters = sel => {
    // Build apiFilters in same shape as Keyword/Category explorer expects
    const apiFilters = {}
    if (sel) {
      if (sel.price) apiFilters.price = sel.price
      if (sel.rating) apiFilters.rating = sel.rating
      if (sel.downloads) apiFilters.downloads = sel.downloads
      if (sel.revenue) apiFilters.revenue = sel.revenue
      if (sel.release_date) apiFilters.release_date = sel.release_date
      if (sel.genre) apiFilters.genre = sel.genre
      if (sel.category) apiFilters.category = sel.category;
      if (sel.bundle) apiFilters.bundle = sel.bundle
      if (sel.number_of_players) apiFilters.number_of_players = sel.number_of_players
      // Accept either `sort_by` (preferred) or legacy `sort` and normalize to sort_by
      if (sel.sort_by) apiFilters.sort_by = sel.sort_by
      else if (sel.sort) apiFilters.sort_by = sel.sort
    }

    setPublisherApiFilters(apiFilters)
    // Persist normalized API-ready filters so reopening panel and badge counts are consistent
    setPublisherFiltersRaw(apiFilters)

    if (apiFilters && Object.keys(apiFilters).length) {
      trackEvent(ANALYTICS_EVENTS.FEATURE.PUBLISHER_EXPLORER_FILTER_APPLIED, { filters: JSON.stringify(apiFilters).slice(0, 100) })
    }

    // persist filters so they survive route changes like Trending page does
    try {
      sessionStorage.setItem('publisherAppliedFilters', JSON.stringify(apiFilters || {}))
    } catch (e) {
      // ignore sessionStorage errors
    }

    // Re-run current search so results update with new filters
    // Prefer the current inputValue (what's in the search box), then last executed searchValue, then selectedChip
    const currentTerm = (inputValue && inputValue.trim())
      ? inputValue.trim()
      : (searchValue && searchValue.trim())
        ? searchValue.trim()
        : (selectedChip || null)

    if (currentTerm) {
      // clear previous results immediately to avoid stale UI while new request is in flight
      setcategoryApps([])
      setCatFilteredApps([])
      // pass apiFilters directly so we don't rely on setState timing
      fetchSearchResult(currentTerm, null, apiFilters)
    }

    setShowFilters(false)
  }

  // Allow removing a single applied filter (key) similar to Trending's remove behavior
  const handleRemovePublisherFilter = (key) => {
    const newFilters = { ...(publisherFiltersRaw || {}) }
    if (!Object.prototype.hasOwnProperty.call(newFilters, key)) return
    delete newFilters[key]
    setPublisherFiltersRaw(newFilters)
    setPublisherApiFilters(newFilters)
    trackEvent(ANALYTICS_EVENTS.FEATURE.PUBLISHER_EXPLORER_FILTER_REMOVED, { filter_key: key })
    try { sessionStorage.setItem('publisherAppliedFilters', JSON.stringify(newFilters || {})) } catch (e) { }

    // Re-run current search (if any) with updated filters
    const currentTerm = (inputValue && inputValue.trim())
      ? inputValue.trim()
      : (searchValue && searchValue.trim())
        ? searchValue.trim()
        : (selectedChip || null)

    if (currentTerm) {
      setcategoryApps([])
      setCatFilteredApps([])
      setIsLoadingResults(true)
      fetchSearchResult(currentTerm, null, newFilters)
    }
  }

  // Upgrade detection helpers (mirror logic from AppTrackingv2)
  const isUpgradeError = error => {
    const response = error?.response
    const data = response?.data || {}
    const status = data?.status
    const action = data?.action || ""
    const current_tier = data?.current_tier || ""
    return status === 400 && action === "UPGRADE" && current_tier
  }

  const isUpgradeResponse = data => {
    if (!data || typeof data !== "object") return false
    const status = data?.status
    const action = data?.action || ""
    const current_tier = data?.current_tier || ""
    return status === 400 && action === "UPGRADE" && current_tier
  }

  // Local state to control upgrade modal visibility
  const [showUpgradeModal, setShowUpgradeModal] = useState(false)
  const handleSearch = async (keywordValue = null) => {
    // In publisher mode, search only triggers via autocomplete dropdown or chip selection
    if (searchType === 'publisher') return;

    const searchValue = keywordValue || inputValue;

    if (!searchValue || searchValue.trim() === "") {
      alert("Please enter a value to search.");
      return;
    }

    // Only clear chip selection for manual search, not keyword clicks
    if (!keywordValue) {
      setSelectedChip(null);
    }

    setIsLoadingResults(true);
    // clear previous results immediately so old list doesn't persist while fetching
    setcategoryApps([])
    setCatFilteredApps([])

    // Set inputValue if searching from keyword click
    if (keywordValue) {
      setInputValue(keywordValue);
    }

    await fetchSearchResult(searchValue);
    try { sessionStorage.setItem('publisherLastSearchType', searchType || 'publisher') } catch (e) { }
    setsearchValue(searchValue);
  };

  // Clear the search input and results (used by the small 'x' clear button)
  const clearSearchInput = () => {
    try {
      trackEvent(ANALYTICS_EVENTS.FEATURE.PUBLISHER_SEARCH_CLEARED, { term: inputValue || searchValue || "" })
      setInputValue("")
      setsearchValue("")
      setSelectedChip(null)
      setcategoryApps([])
      setCatFilteredApps([])
      setIsLoadingResults(false)
      // Clear any cached category summary so KPI cards reset (e.g. Average App Score -> 0.0)
      setcategoryData([])
    } catch (err) {
      console.error('Error clearing search input:', err)
    }
  }

  // Cancel an ongoing search: signals the fetch loop to stop and resets all state
  const handleCancelSearch = () => {
    cancelRef.current = true
    setIsLoadingResults(false)
    setcategoryApps([])
    setCatFilteredApps([])
  }


  // Callback function to handle the platform and select data from the navtabs
  const handlePlatformChange = platform => {
    changePlatform(platform) // Update the platform
    trackEvent(ANALYTICS_EVENTS.FEATURE.PUBLISHER_EXPLORER_PLATFORM_CHANGED, { platform })

    // When platform changes, re-run the last search (if any) so backend gets the platform filter.
    // In publisher mode, inputValue is unconfirmed typed text — only use a term that was
    // actually confirmed via dropdown selection or chip click.
    const currentTerm = searchType === 'publisher'
      ? ((searchValue && searchValue.trim()) ? searchValue.trim() : (selectedChip || null))
      : ((inputValue && inputValue.trim())
          ? inputValue.trim()
          : (searchValue && searchValue.trim())
            ? searchValue.trim()
            : (selectedChip || null))

    // If we don't have a term, just re-filter client-side results
    if (!currentTerm) {
      const platformFilteredGames = platform !== "all"
        ? categoryApps.filter(game => game.platform === platform)
        : categoryApps // If "all", return all games

      setCatFilteredApps(platformFilteredGames)
      return
    }

    // Otherwise clear current results and fetch with new platform
    setcategoryApps([])
    setCatFilteredApps([])
    // use platformOverride so fetch uses the freshly selected platform immediately
    const platformOverride = platform
    fetchSearchResult(currentTerm, platformOverride)
  }

  const formatNumber = num => {
    if (num == null || num === "") return "0"
    // Coerce strings (including scientific notation) to number when possible
    let n = typeof num === 'string' ? Number(num.replace(/,/g, '')) : Number(num)
    if (!isFinite(n)) {
      // fallback: try parseFloat
      n = parseFloat(String(num).replace(/,/g, ''))
    }
    if (!isFinite(n)) return String(num)

    const abs = Math.abs(n)
    if (abs >= 1e9) return (n / 1e9).toFixed(1).replace(/\.0$/, '') + 'B'
    if (abs >= 1e6) return (n / 1e6).toFixed(1).replace(/\.0$/, '') + 'M'
    if (abs >= 1e3) return (n / 1e3).toFixed(1).replace(/\.0$/, '') + 'K'
    // small numbers: show localized integer (no exponential)
    return n % 1 === 0 ? n.toLocaleString() : n.toLocaleString(undefined, { maximumFractionDigits: 2 })
  }

  // Capitalize only the first letter for display (don't mutate the original value)
  const capitalizeFirst = (s) => {
    if (s === undefined || s === null) return '';
    const str = String(s).trim();
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  window.onerror = function (message, source, lineno, colno, error) {
  };

  // Small internal component: resolves a sensible item_id and navigates to publisher dashboard
  const GoToPublisherButton = ({ categoryApps, selectedChip, inputValue, topPublishers }) => {
    const navigate = useNavigate()
    const [resolving, setResolving] = useState(false)

    const handleGo = async () => {
      setResolving(true)
      try {
        // Resolved publisher name, used both to resolve itemId below and for analytics
        const publisherQuery = selectedChip || inputValue || (topPublishers && topPublishers[0])
        // Prefer the current results first
        let itemId = categoryApps && categoryApps.length ? (categoryApps[0].item_id || categoryApps[0]?.game_details?.item_id) : null
        let itemName = categoryApps && categoryApps.length ? (categoryApps[0].name || categoryApps[0]?.game_details?.name) : null

        // If we don't have an item id, try to resolve by publisher name
        if (!itemId) {
          if (publisherQuery) {
            // Build params matching keyword explorer: include platform and any active filters
            const goParams = { query: publisherQuery }
            goParams.platform = selectedPlatform || ''
            if (publisherApiFilters && typeof publisherApiFilters === 'object') {
              Object.entries(publisherApiFilters).forEach(([k, v]) => {
                if (v === undefined || v === null || v === '') return
                if (Array.isArray(v)) goParams[k] = v.join(', ')
                else goParams[k] = v
              })
            }

            const res = await axios.get(`${api}/tracker/publisher/search`, {
              params: goParams,
              headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
            })
            const first = res?.data?.results?.[0]
            itemId = first?.item_id || first?.game_details?.item_id
            itemName = first?.name || first?.game_details?.name
          }
        }

        if (itemId) {
          trackEvent(ANALYTICS_EVENTS.FEATURE.PUBLISHER_DASHBOARD_VIEWED, {
            publisher_name: publisherQuery,
            app_id: itemId,
            app_name: itemName,
            platform: selectedPlatform,
          })
          navigate(`/publisher-apps/${itemId}`)
        } else {
          // fallback to publisher apps landing if we couldn't resolve an app id
          navigate('/publisher-apps')
        }
      } catch (err) {
        console.error('Error resolving publisher dashboard destination', err)
        navigate('/publisher-apps')
      } finally {
        setResolving(false)
      }
    }

    return (
      <button
        onClick={handleGo}
        disabled={resolving}
        className="go-to-publisher-btn"
        aria-label="Open publisher dashboard"
      >
        {resolving ? (
          <span className="go-loading">Opening...</span>
        ) : (
          <>
            <svg className="go-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
              <path d="M12 2L12 12" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M5 9L12 16L19 9" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span className="go-label">Looking for publisher dashboard?</span>
          </>
        )}
      </button>
    )
  }

  // compute chipList used by the chips UI
  const chipList = (searchType === 'publisher')
    ? (predefPublishers && predefPublishers.length ? predefPublishers.map(p => p.name) : topPublishers)
    : predefCategory

  const { progress, showProgressModal, cancel: cancelSearchProgress } = useSearchProgress({
    loading: isLoadingResults,
  })

  const handleCancelProgress = () => {
    cancelSearchProgress()
    handleCancelSearch()
  }

  return (
    <React.Fragment>
      <SearchProgressModal
        show={showProgressModal}
        progress={progress}
        title="Searching publishers"
        onCancel={handleCancelProgress}
        hasResults={categoryApps.length > 0}
      />
      <SEO
        title={PAGE_SEO.publisherAnalysis.title}
        description={PAGE_SEO.publisherAnalysis.description}
        keywords={PAGE_SEO.publisherAnalysis.keywords}
        canonical={generateCanonicalUrl('/publisher-analysis')}
        robots={PAGE_SEO.publisherAnalysis.robots}
        structuredData={[STRUCTURED_DATA.organization, STRUCTURED_DATA.website]}
        pageType="publisherAnalysis"
      />
      {/* marginTop: 0 cancels .category-analysis's own margin-top (64px/56px —
          see components/CategoryAnalysis/style/index.scss), which exists so that
          class works standalone (e.g. CategoryAnalysisContainer.jsx has no
          .page-content). Here .page-content already provides the correct
          topbar offset, so keeping that margin-top would double it up. */}
      <div className="page-content category-analysis" style={{ paddingLeft: '32px', paddingRight: '32px', paddingBottom: '32px', marginTop: 0 }}>
        {/* Modern Header Section (styled like Category Explorer) */}
        <header className="ca-header">
          <div className="ca-header__content">
            <div className="ca-header__titles">
              <h1 className="ca-header__title">Publisher Explorer</h1>
              <p className="ca-header__subtitle">
                Search all publishers and developers across the Meta and Steam platforms and access all their game data in one place — enhanced by KeyQuest’s powerful AI analytics.
                Discover performance, rankings, and metrics for top publishers and developers and their catalog of games, all in a unified dashboard.
              </p>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <form
                className='d-flex align-items-center flex-row gap-3 gap-sm-4'
                style={{ flex: 1 }}
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSearch();
                }}
              >
                {/* Search Type Selector */}
                <div className="searchTypeSelector">
                  <select
                    value={searchType}
                    onChange={e => {
                      const val = e.target.value
                      setSearchType(val)
                      trackEvent(ANALYTICS_EVENTS.FEATURE.PUBLISHER_EXPLORER_SEARCH_MODE_CHANGED, { mode: val })
                      // Clear previous search results and inputs when switching modes
                      setcategoryApps([])
                      setCatFilteredApps([])
                      setIsLoadingResults(false)
                      setsearchValue("")
                      setInputValue("")
                      setSelectedChip(null)
                      // Ensure filter panel is closed when switching modes to avoid it remaining open
                      setShowFilters(false)

                      if (val === 'publisher') {
                        // refresh top publishers when switching to publisher mode
                        fetchTopPublishers()
                      }
                    }}
                    style={{
                      background: '#21222D',
                      border: 'none',
                      outline: 'none',
                      color: '#fff',
                      fontSize: 15,
                      padding: '12px 16px',
                      borderRadius: '8px',
                      appearance: 'none',
                      minWidth: '180px',
                    }}
                  >
                    <option value="publisher">Search by Publisher</option>
                    <option value="keyword">Search by Keyword</option>
                  </select>
                  <svg
                    style={{
                      position: 'absolute',
                      right: '16px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      pointerEvents: 'none'
                    }}
                    width="12"
                    height="8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M1 1L6 6L11 1" stroke="#b0b0b5" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </div>

                <div
                  className='searchField d-flex align-items-center'
                  ref={suggestionsRef}
                  style={{ position: 'relative' }}
                >
                  <span style={{ color: '#b0b0b5', marginRight: 8, fontSize: 18 }}>
                    <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.5 12.5L16 16" stroke="#b0b0b5" strokeWidth="2" strokeLinecap="round" />
                      <circle cx="8.5" cy="8.5" r="6.5" stroke="#b0b0b5" strokeWidth="2" />
                    </svg>
                  </span>
                  <input
                    type="text"
                    placeholder={searchType === 'publisher' ? 'Type publisher name...' : 'Search by name or paste a URL...'}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      outline: 'none',
                      color: '#fff',
                      fontSize: 15,
                      width: '100%',
                    }}
                    value={inputValue}
                    onChange={e => {
                      setInputValue(e.target.value)
                      if (searchType === 'publisher') setShowSuggestions(true)
                    }}
                    onFocus={() => {
                      if (searchType === 'publisher' && publisherSuggestions.length > 0) setShowSuggestions(true)
                    }}
                    onKeyDown={handleKeyDown}
                    autoComplete="off"
                  />
                  {/* Clear (x) button shown when there's text in the input */}
                  {inputValue && inputValue.trim() !== '' && (
                    <button
                      type="button"
                      className="clear-input-btn"
                      onClick={clearSearchInput}
                      aria-label="Clear search"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18" stroke="#b0b0b5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M6 6L18 18" stroke="#b0b0b5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  )}

                  {/* Publisher autocomplete dropdown */}
                  {searchType === 'publisher' && showSuggestions && (
                    <div className="publisher-suggestions-dropdown">
                      {suggestionsLoading ? (
                        <div className="publisher-suggestions-loading">
                          <div className="suggest-spinner" />
                          <span>Searching publishers…</span>
                        </div>
                      ) : publisherSuggestions.length > 0 ? (
                        publisherSuggestions.map((item, idx) => {
                          const name = getSuggestionName(item)
                          return (
                            <div
                              key={idx}
                              className={`publisher-suggestion-item${highlightedSuggestion === idx ? ' highlighted' : ''}`}
                              onMouseDown={(e) => { e.preventDefault(); handleSelectSuggestion(item) }}
                              onMouseEnter={() => setHighlightedSuggestion(idx)}
                            >
                              <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ opacity: 0.5, flexShrink: 0 }}>
                                <circle cx="7" cy="7" r="6" stroke="#b0b0b5" strokeWidth="1.5" />
                                <path d="M7 4v3l2 2" stroke="#b0b0b5" strokeWidth="1.5" strokeLinecap="round" />
                              </svg>
                              <span>{name}</span>
                            </div>
                          )
                        })
                      ) : null}
                    </div>
                  )}
                </div>
                {searchType !== 'publisher' && (
                  <div style={{ position: 'relative' }}>
                    <button
                      ref={searchButtonRef}
                      className="searchBtn"
                      type="submit"
                      disabled={isLoadingResults}
                    >
                      {isLoadingResults ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <div className="search-spinner"></div>
                        </div>
                      ) : (
                        'Search'
                      )}
                    </button>
                  </div>
                )}
                {searchType !== 'publisher' && (
                  <>
                    <div className="filter-button-wrapper" style={{ marginLeft: 8, position: 'relative' }}>
                      <button
                        ref={filterButtonRef}
                        type="button"
                        className="filter-trigger"
                        onClick={() => setShowFilters(true)}
                        aria-expanded={showFilters}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ marginRight: 8 }} xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 18h4v-2h-4v2zM4 6h16v2H4V6zm3 6h10v-2H7v2z" fill="#fff" />
                        </svg>
                        Filter
                        {publisherFiltersRaw && Object.keys(publisherFiltersRaw).length > 0 && (
                          <span className="filter-badge">
                            {Object.values(publisherFiltersRaw).reduce((acc, v) => {
                              if (v == null) return acc
                              if (Array.isArray(v)) return acc + v.length
                              if (typeof v === 'string' || typeof v === 'number') return acc + (String(v).trim() ? 1 : 0)
                              return acc + 1
                            }, 0)}
                          </span>
                        )}
                      </button>
                    </div>

                    {showFilters && (
                      <FilterPanel
                        open={showFilters}
                        sections={filterSections.length > 0 ? filterSections : undefined}
                        initialValues={publisherFiltersRaw}
                        onClose={() => setShowFilters(false)}
                        onApply={handleApplyPublisherFilters}
                        lockedOptions={[]}
                        onLockClick={() => setShowUpgradeModal(true)}
                        anchorRef={filterButtonRef}
                        leftOffset={100}
                        gap={4}
                      />
                    )}
                  </>
                )}
              </form>
              {/* CTA moved to Publisher Intelligence section to align with its title */}
            </div>
          </div>
        </header>

        {/* contextual helper text placed under the search controls */}
        <div className="search-context-text" style={{ padding: '0 0 8px 8px' }}>
          {searchType === 'keyword'
            ? 'Showing games of all publishers with the searched keyword.'
            : 'Showing publishers based on the searched name'}
        </div>
        {/* Applied Filters (persisted) - same style as Trending/PreOrders badges */}
        {publisherFiltersRaw && Object.keys(publisherFiltersRaw).length > 0 && (
          <div style={{ marginTop: '8px', marginBottom: '1rem', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {Object.entries(publisherFiltersRaw).map(([k, v]) => {
              const displayVal = Array.isArray(v) ? v.join(', ') : (v === null || v === undefined || v === '' ? 'Any' : String(v))
              return (
                <span key={k} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 8px', background: 'linear-gradient(90deg, rgba(255,154,184,0.12), rgba(246,37,90,0.12))', color: '#F6255A', borderRadius: '6px', fontSize: '12px', fontWeight: 500 }}>
                  <span style={{ textTransform: 'capitalize', marginRight: 4 }}>{k.replace(/_/g, ' ')}:</span>
                  <span style={{ opacity: 0.9, color: '#F6255A' }}>{displayVal}</span>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      handleRemovePublisherFilter(k);
                    }}
                    aria-label={`Remove filter ${k}`}
                    style={{
                      marginLeft: 4,
                      background: 'transparent',
                      border: 'none',
                      color: '#F6255A',
                      cursor: 'pointer',
                      fontSize: 12,
                      lineHeight: 0.9
                    }}
                  >
                    ×
                  </button>
                </span>
              )
            })}
          </div>
        )}
        <div style={{ paddingTop: 8 }}>
          <PlatformTabs activeTab={selectedPlatform} onChange={handlePlatformChange} variant="pill" />
        </div>
        {/* Publisher Intelligence Cards */}
        <div className="publisher-intel-root">
          <div className="publisher-intel-header">
            <h2 className="publisher-intel-title" style={{ fontSize: '25.2px', fontWeight: 500 }}>Publisher Intelligence</h2>
            <div className="publisher-intel-cta">
              <GoToPublisherButton
                categoryApps={categoryApps}
                selectedChip={selectedChip}
                inputValue={inputValue}
                topPublishers={topPublishers}
              />
            </div>
          </div>
          {/* Publisher header removed per request */}
          <div className="row gx-5 row-cols-md-3 gap-md-0 gap-4">
            <div className='col-12 col-md-3'>
              {/* Total Apps Card */}
              <div className="publisher-intel-card d-flex justify-content-between flex-column">
                <div className='d-flex align-items-center justify-content-between w-100'>
                  <div className="publisher-intel-icon-wrap">
                    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 14.9999C1.10218 14.9999 0.720645 14.8419 0.43934 14.5606C0.158036 14.2793 0 13.8978 0 13.4999V1.50293C0 1.1051 0.158036 0.723574 0.43934 0.44227C0.720645 0.160965 1.10218 0.00292969 1.5 0.00292969H13.5C13.8978 0.00292969 14.2794 0.160965 14.5607 0.44227C14.842 0.723574 15 1.1051 15 1.50293V13.4999C15 13.8978 14.842 14.2793 14.5607 14.5606C14.2794 14.8419 13.8978 14.9999 13.5 14.9999H1.5ZM22.5 14.9999C22.1022 14.9999 21.7206 14.8419 21.4393 14.5606C21.158 14.2793 21 13.8978 21 13.4999V1.50293C21 1.1051 21.158 0.723574 21.4393 0.44227C21.7206 0.160965 22.1022 0.00292969 22.5 0.00292969H34.497C34.8948 0.00292969 35.2764 0.160965 35.5577 0.44227C35.839 0.723574 35.997 1.1051 35.997 1.50293V13.4999C35.997 13.8978 35.839 14.2793 35.5577 14.5606C35.2764 14.8419 34.8948 14.9999 34.497 14.9999H22.5ZM1.5 35.9999C1.10218 35.9999 0.720645 35.8419 0.43934 35.5606C0.158036 35.2793 0 34.8978 0 34.4999V22.4999C0 22.1021 0.158036 21.7206 0.43934 21.4393C0.720645 21.158 1.10218 20.9999 1.5 20.9999H13.5C13.8978 20.9999 14.2794 21.158 14.5607 21.4393C14.842 21.7206 15 22.1021 15 22.4999V34.4999C15 34.8978 14.842 35.2793 14.5607 35.5606C14.2794 35.8419 13.8978 35.9999 13.5 35.9999H1.5ZM22.5 35.9999C22.1022 35.9999 21.7206 35.8419 21.4393 35.5606C21.158 35.2793 21 34.8978 21 34.4999V22.4999C21 22.1021 21.158 21.7206 21.4393 21.4393C21.7206 21.158 22.1022 20.9999 22.5 20.9999H34.497C34.8948 20.9999 35.2764 21.158 35.5577 21.4393C35.839 21.7206 35.997 22.1021 35.997 22.4999V34.4999C35.997 34.8978 35.839 35.2793 35.5577 35.5606C35.2764 35.8419 34.8948 35.9999 34.497 35.9999H22.5Z" fill="#20AEF3" />
                    </svg>
                  </div>
                  <div className="publisher-intel-card-content">
                    <div className="publisher-intel-card-label">Total Games</div>
                    <div className="publisher-intel-card-value">{categoryApps.length}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-3'>
              {/* Total Revenue Card */}
              <div className="publisher-intel-card d-flex justify-content-between flex-column">
                <div className='d-flex align-items-center justify-content-between w-100'>
                  <div className="publisher-intel-icon-wrap">
                    <svg width="48" height="46" viewBox="0 0 48 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M17.3697 0.0621416C7.48387 1.10567 0.5775 10.1616 2.25056 19.8873C3.03366 24.4397 5.66794 28.5192 9.46875 31.0654C10.213 31.564 11.6293 32.3473 11.9668 32.447C12.1223 32.493 13.0359 31.9607 15.9981 30.0981C21.072 26.9077 20.9695 26.9691 21.5557 26.7675C22.3252 26.5027 23.1832 26.4545 23.9435 26.633C25.0936 26.9032 25.5824 27.2409 27.3923 29.0155C28.63 30.2291 29.0856 30.6213 29.1894 30.5628C29.589 30.3378 31.0478 28.9929 31.7037 28.2448C35.8638 23.5004 37.1021 16.9955 34.9597 11.1421C33.364 6.7828 29.8974 3.15252 25.5938 1.33395C24.3526 0.809423 23.2182 0.479235 21.8438 0.242235C20.6045 0.0284853 18.493 -0.0564522 17.3697 0.0621416ZM18.4688 7.1053C18.3399 7.15677 18.1356 7.2912 18.0145 7.40408C17.6108 7.78114 17.5312 8.05798 17.5312 9.08764V10.0595L16.9922 10.2294C13.9762 11.18 13.0398 14.9923 15.2738 17.2263C16.2478 18.2003 17.2472 18.5217 19.3233 18.5284C20.3156 18.5315 20.5788 18.645 20.8612 19.1912C21.1363 19.723 20.9758 20.378 20.4736 20.773C20.2362 20.9597 20.1156 20.9688 17.8702 20.9693C16.4503 20.9696 15.3685 21.0107 15.145 21.0727C13.8504 21.4321 13.6392 23.2029 14.8192 23.8045C15.0754 23.9352 15.3833 23.9685 16.3359 23.9686L17.5312 23.9688V24.917C17.5312 26.0372 17.6987 26.4426 18.3013 26.7813C18.9946 27.1709 19.9476 26.8901 20.3144 26.1879C20.4198 25.9863 20.4834 25.5694 20.5121 24.8922L20.5546 23.8938L20.826 23.8395C21.3739 23.7299 22.1857 23.2537 22.7136 22.7323C23.672 21.7856 24.1574 20.3249 23.9265 19.0829C23.7051 17.8922 22.9979 16.8079 22.0435 16.1954C21.2663 15.6965 20.8838 15.6058 19.2959 15.5427C17.6436 15.4772 17.4505 15.4065 17.1232 14.7477C16.8928 14.2843 16.9805 13.8368 17.3889 13.3909L17.7039 13.0469L20.3129 13C22.7121 12.9569 22.9482 12.9379 23.25 12.7635C23.6082 12.5565 24 11.8965 24 11.5C24 11.0362 23.6101 10.438 23.1598 10.211C22.7974 10.0282 22.5955 10 21.6487 10H20.5558L20.5127 9.02914C20.4776 8.2408 20.4306 7.99527 20.2625 7.7233C19.9097 7.15255 19.0732 6.86436 18.4688 7.1053Z" fill="#A9DFD8" />
                    </svg>
                  </div>
                  <div className="publisher-intel-card-content">
                    <div className="publisher-intel-card-label">
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, justifyContent: 'flex-end', width: '100%' }}>
                        <span>Total Revenue</span>
                        <span
                          title="Add-ons revenue included in total"
                          style={{ display: 'inline-flex', alignItems: 'center' }}
                        >
                          <Info size={14} style={{ opacity: 0.8, cursor: 'default' }} />
                        </span>
                      </span>
                    </div>
                    <div
                      className="publisher-intel-card-value"
                      style={{ fontSize: 28, textAlign: 'right' }}
                      title="Add-ons revenue included in total"
                    >
                      {(() => {
                        // Treat numeric values safely and detect locked placeholders coming from the API
                        const LOCK_PLACEHOLDER = "%UPGRADE_KEYQ%"

                        // Check if any app has the revenue placeholder (means backend hid revenue)
                        const hasLockedRevenue = categoryApps.some(app => {
                          if (!app) return false
                          const r = app.revenue ?? app?.stats?.revenue
                          return r === LOCK_PLACEHOLDER
                        })

                        // Sum only numeric (finite) revenue values, ignore placeholders and non-numeric
                        const totalRev = categoryApps.reduce((sum, app) => {
                          if (!app) return sum
                          const r = app.revenue ?? app?.stats?.revenue
                          if (r == null) return sum
                          if (typeof r === 'number') return sum + (isFinite(r) ? r : 0)
                          // try to coerce string numbers, ignore placeholder
                          if (typeof r === 'string') {
                            if (r === LOCK_PLACEHOLDER) return sum
                            const n = Number(String(r).replace(/[,\s]/g, ''))
                            return isFinite(n) ? sum + n : sum
                          }
                          return sum
                        }, 0)

                        const formatted = totalRev >= 1000000 ? `$${(totalRev / 1000000).toFixed(1)}M` : totalRev >= 1000 ? `$${Math.round(totalRev / 1000)}K` : `$${Math.round(totalRev)}`

                        const shouldLock = hasLockedRevenue

                        return shouldLock ? (
                          <span
                            title={"Unlock detailed analytics powered by KeyQuest’s proprietary data models."}
                            onClick={() => setShowUpgradeModal(true)}
                            style={{ display: "inline-flex", alignItems: "center", gap: 8, cursor: "pointer" }}
                            role="button"
                          >
                            <span style={{ filter: "blur(4px)", WebkitFilter: "blur(4px)" }}>{formatted}</span>
                            <i className="fas fa-lock" aria-hidden="true" style={{ fontSize: 12, color: '#fff' }} />
                          </span>
                        ) : (
                          formatted
                        )
                      })()}
                    </div>
                  </div>
                </div>
                <div>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-3'>
              {/* Total Downloads Card (replaces Avg Rating) */}
              <div className="publisher-intel-card d-flex justify-content-between flex-column">
                <div className='d-flex align-items-center justify-content-between w-100'>
                  <div className="publisher-intel-icon-wrap">
                    {/* Download icon */}
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 3v12" stroke="#A9DFD8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M8 11l4 4 4-4" stroke="#A9DFD8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M21 21H3" stroke="#A9DFD8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <div className="publisher-intel-card-content">
                    <div className="publisher-intel-card-label">Total Downloads</div>
                    <div className="publisher-intel-card-value">
                      {(() => {
                        const LOCK_PLACEHOLDER = "%UPGRADE_KEYQ%"

                        // if any app has downloads placeholder, treat whole downloads as locked
                        const hasLockedDownloads = categoryApps.some(app => {
                          if (!app) return false
                          const d = app?.downloads ?? app?.stats?.downloads
                          return d === LOCK_PLACEHOLDER
                        })

                        const totalDownloads = categoryApps.reduce((sum, app) => {
                          if (!app) return sum
                          const d = app?.downloads ?? app?.stats?.downloads
                          if (d == null) return sum
                          if (typeof d === 'number') return sum + (isFinite(d) ? d : 0)
                          if (typeof d === 'string') {
                            if (d === LOCK_PLACEHOLDER) return sum
                            const n = Number(String(d).replace(/[,\s]/g, ''))
                            return isFinite(n) ? sum + n : sum
                          }
                          return sum
                        }, 0)

                        const formatted = formatNumber(totalDownloads)
                        const shouldLock = hasLockedDownloads

                        return shouldLock ? (
                          <span
                            title={"Unlock detailed analytics powered by KeyQuest’s proprietary data models."}
                            onClick={() => setShowUpgradeModal(true)}
                            style={{ display: "inline-flex", alignItems: "center", gap: 8, cursor: "pointer" }}
                            role="button"
                          >
                            <span style={{ filter: "blur(4px)", WebkitFilter: "blur(4px)", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{formatted}</span>
                            <i className="fas fa-lock" aria-hidden="true" style={{ fontSize: 12, color: '#fff' }} />
                          </span>
                        ) : (
                          <span style={{ display: 'inline-block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{formatted}</span>
                        )
                      })()}
                    </div>
                  </div>
                </div>
                <div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-3'>
              {/* Average App Score + Top apps */}
              <div className="publisher-intel-card d-flex justify-content-between flex-column">
                <div className='d-flex align-items-center justify-content-between w-100'>
                  <div className="publisher-intel-icon-wrap">
                    {/* Star / Score icon */}
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" stroke="#A9DFD8" strokeWidth="0" fill="#A9DFD8" />
                    </svg>
                  </div>
                  <div className="publisher-intel-card-content">
                    <div className="publisher-intel-card-label">Average App Score</div>
                    <div className="publisher-intel-card-value" style={{ fontSize: 28 }}>
                      {(() => {
                        // Prefer API-provided average ASR when available (response may include summary.average_asr)
                        const apiAvg = categoryData?.summary?.average_asr ?? categoryData?.average_asr ?? null
                        if (apiAvg != null && isFinite(Number(apiAvg))) {
                          // Show numeric API value, rounded to 1 decimal if it has fractional part
                          return Number(apiAvg) % 1 === 0 ? String(Number(apiAvg)) : Number(apiAvg).toFixed(1)
                        }

                        // Fallback: compute average rating (one decimal) only for the active keyword/filter results (filteredApps),
                        // otherwise fallback to the full categoryApps. Default to 0.0 when no data.
                        const pool = (filteredApps && filteredApps.length) ? filteredApps : categoryApps
                        if (!pool || pool.length === 0) return '0.0'
                        const ratings = pool.map(a => {
                          if (typeof a.rating === 'number') return a.rating
                          if (a.rating_index != null) return Math.round((a.rating_index / 100) * 10) / 10
                          if (a.game_details && typeof a.game_details.rating === 'number') return a.game_details.rating
                          return null
                        }).filter(Boolean)
                        const avg = ratings.length ? (ratings.reduce((s, r) => s + r, 0) / ratings.length) : null
                        const avgDisplay = avg != null ? avg.toFixed(1) : '0.0'
                        return avgDisplay
                      })()}
                    </div>
                  </div>
                </div>
                <div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Modern Filter Tabs */}
        {searchType === 'publisher' ? (
          <h2 className="publisher-intel-title" style={{ margin: '16px 0 16px', fontSize: 16, fontWeight: 500, color: 'rgba(255,255,255,0.8)' }}>Top Publishers</h2>
        ) : searchType === 'keyword' ? (
          <div className="keywords-section">
            <h2 className="publisher-intel-title" style={{ margin: '16px 0 16px', fontSize: 16, fontWeight: 500, color: 'rgba(255,255,255,0.8)' }}>
              Top Trending Keywords
            </h2>
            <p className="trending-disclaimer" style={{ fontSize: '0.75rem', fontStyle: 'italic', opacity: 0.6 }}>Top trending keywords of last week</p>
          </div>
        ) : null}
        {/* Trending Keywords / Publisher Chips */}
        <div
          ref={chipsSectionRef}
          className="chips-section"
          style={{ position: 'relative' }}
        >
          <div className="chips-row">
            {chipList && chipList.length > 0 ? (
              // chipList already computed depending on mode
              chipList.map((value, index) => {
                const isSelected = selectedChip === value || (inputValue === value && chipList.includes(inputValue));
                return (
                  <button
                    key={index}
                    className={`publisher-chip ${isSelected ? 'selected' : ''}`}
                    onClick={() => predefSearch(value)}
                  >
                    {capitalizeFirst(value)}
                  </button>
                )
              })
            ) : (
              // skeleton while loading/no data
              Array.from({ length: 6 }).map((_, idx) => (
                <div
                  key={idx}
                  className="publisher-chip-skeleton"
                  style={{
                    width: `${Math.random() * 60 + 80}px`,
                    height: "32px",
                    backgroundColor: "#2a2a35",
                    borderRadius: "20px",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                />
              ))
            )}
          </div>
        </div>


        {/* Results Section */}
        <div className="mt-4">
          {isLoadingResults ? (
            <div className="results-skeleton">
              {Array.from({ length: 5 }).map((_, index) => (
                <div key={index} className="skeleton-row">
                  <div className="skeleton-avatar"></div>
                  <div className="skeleton-content">
                    <div className="skeleton-title"></div>
                    <div className="skeleton-subtitle"></div>
                  </div>
                  <div className="skeleton-stats">
                    <div className="skeleton-stat"></div>
                    <div className="skeleton-stat"></div>
                    <div className="skeleton-stat"></div>
                  </div>
                </div>
              ))}
            </div>
          ) : categoryApps.length > 0 && filteredApps.length > 0 ? (
            <>
              <PublisherDataTable
                // Use the last executed search term so live typing doesn't mutate displayed category labels
                inputdata={searchValue}
                searchType={searchType}
                gamesData={filteredApps}
                onLockClick={() => setShowUpgradeModal(true)}
              />
            </>
          ) : !selectedChip && !inputValue ? (
            <div className="no-selection-message">
              <div className="no-selection-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 4C35.046 4 44 12.954 44 24C44 35.046 35.046 44 24 44C12.954 44 4 35.046 4 24C4 12.954 12.954 4 24 4ZM24 8C15.163 8 8 15.163 8 24C8 32.837 15.163 40 24 40C32.837 40 40 32.837 40 24C40 15.163 32.837 8 24 8ZM24 30C25.657 30 27 31.343 27 33C27 34.657 25.657 36 24 36C22.343 36 21 34.657 21 33C21 31.343 22.343 30 24 30ZM24 12C25.657 12 27 13.343 27 15V25C27 26.657 25.657 28 24 28C22.343 28 21 26.657 21 25V15C21 13.343 22.343 12 24 12Z" fill="#b0b0b5" />
                </svg>
              </div>
              <h3 style={{ fontSize: '21.6px', fontWeight: 500 }}>Select a Publisher or Search</h3>
              <p>Choose a publisher from the categories above or use the search field to find specific publishers and see their app portfolio.</p>
            </div>
          ) : categoryApps.length > 0 && filteredApps.length === 0 ? (
            <div className="no-platform-data-message">
              <div className="no-platform-data-icon">
                {selectedPlatform === 'meta' ? (
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24 4C13.507 4 5 12.507 5 23C5 33.493 13.507 42 24 42C34.493 42 43 33.493 43 23C43 12.507 34.493 4 24 4ZM24 38C15.716 38 9 31.284 9 23C9 14.716 15.716 8 24 8C32.284 8 39 14.716 39 23C39 31.284 32.284 38 24 38ZM18 16C16.895 16 16 16.895 16 18C16 19.105 16.895 20 18 20C19.105 20 20 19.105 20 18C20 16.895 19.105 16 18 16ZM30 16C28.895 16 28 16.895 28 18C28 19.105 28.895 20 30 20C31.105 20 32 19.105 32 18C32 16.895 31.105 16 30 16ZM16 26C16 30.418 19.582 34 24 34C28.418 34 32 30.418 32 26H16Z" fill="#1877F2" />
                  </svg>
                ) : (
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24 4C35.046 4 44 12.954 44 24C44 35.046 35.046 44 24 44C12.954 44 4 35.046 4 24C4 12.954 12.954 4 24 4ZM24 8C15.163 8 8 15.163 8 24C8 32.837 15.163 40 24 40C32.837 40 40 32.837 40 24C40 15.163 32.837 8 24 8ZM22 14H26V22H34V26H26V34H22V26H14V22H22V14Z" fill="#b0b0b5" />
                  </svg>
                )}
              </div>
              <h3 style={{ fontSize: '21.6px', fontWeight: 500 }}>No {(() => {
                const platform = getActivePlatforms().find(p => p.id === selectedPlatform);
                return platform ? platform.display_name : 'Platform';
              })()} Data Available</h3>
              <p>
                {getActivePlatforms().length > 1
                  ? (() => {
                      const platform = getActivePlatforms().find(p => p.id === selectedPlatform);
                      const otherPlatform = getActivePlatforms().find(p => p.id !== selectedPlatform);
                      return `No ${platform ? platform.display_name : 'Platform'} apps found for "${searchValue || selectedChip}". The publisher might only have games on ${otherPlatform ? otherPlatform.display_name : 'other platforms'}.`;
                    })()
                  : `No apps found for this platform filter.`
                }
              </p>
              {getActivePlatforms().length > 1 && (
                <div className="platform-suggestion">
                  <p>Try switching to <strong>{getActivePlatforms().find(p => p.id !== selectedPlatform)?.display_name}</strong> to see more results.</p>
                </div>
              )}
            </div>
          ) : (
            <div className="no-results-message">
              <div className="no-results-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M33.728 32.314L39.899 38.485C40.679 39.265 40.679 40.535 39.899 41.315C39.119 42.095 37.849 42.095 37.069 41.315L30.898 35.144C27.473 37.756 23.11 39.2 18.4 39.2C8.724 39.2 0.8 31.276 0.8 21.6C0.8 11.924 8.724 4 18.4 4C28.076 4 36 11.924 36 21.6C36 26.31 34.556 30.673 31.944 34.098L33.728 32.314ZM18.4 8C10.928 8 4.8 14.128 4.8 21.6C4.8 29.072 10.928 35.2 18.4 35.2C25.872 35.2 32 29.072 32 21.6C32 14.128 25.872 8 18.4 8Z" fill="#b0b0b5" />
                </svg>
              </div>
              <h3 style={{ fontSize: '21.6px', fontWeight: 500 }}>No Results Found</h3>
              <p>No publishers found for "{searchValue}". Try searching with a different term or select a category above.</p>
            </div>
          )}
        </div>
      </div>

      {/* Upgrade Modal */}
      <AppsTrackingPlanModal
        show={showUpgradeModal}
        handleClose={() => setShowUpgradeModal(false)}
        title=" Upgrade your plan to unlock this feature"
      />



      {/* CSS Styles */}
      <style>{`
        /* Header Styles */
        .pageHeader {
          padding: 44px 0 30px 0;
          width: 100%;
          margin-top: 64px;
        }
        .pageTitle {
          font-weight: 600;
          font-size: 32px;
          line-height: 100%;
          color: #fff;
          font-family: Rubik;
        }
        .pageSubTitle {
          font-family: Rubik;
          font-weight: 400;
          font-size: 16px;
          line-height: 100%;
          letter-spacing: 0%;
          color: #fff;
          margin-bottom: 24px;
        }
        .searchTypeSelector {
          position: relative;
          display: flex;
          align-items: center;
        }
        .searchField {
          background-color: #21222D;
          height: 44px;
          border-radius: 8px;
          width: 500px;
          padding: 12px 16px;
        }
        .searchField input {
          font-size: 16px;
        }
        .searchField input::placeholder {
          color: #D2D2D2;
        }

        /* Clear (x) button inside search field */
        .clear-input-btn {
          background: transparent;
          border: none;
          color: #b0b0b5;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          margin-left: 8px;
          padding: 6px;
          border-radius: 6px;
        }
        .clear-input-btn:hover {
          background: rgba(255,255,255,0.03);
        }

        /* Publisher autocomplete dropdown */
        .publisher-suggestions-dropdown {
          position: absolute;
          top: calc(100% + 6px);
          left: 0;
          right: 0;
          background: #21222D;
          border: 1px solid #353748;
          border-radius: 10px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.45);
          z-index: 1000;
          max-height: 280px;
          overflow-y: auto;
          padding: 4px 0;
        }
        .publisher-suggestion-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 16px;
          color: #d0d0d8;
          font-size: 14px;
          cursor: pointer;
          transition: background 0.12s, color 0.12s;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .publisher-suggestion-item:hover,
        .publisher-suggestion-item.highlighted {
          background: rgba(244,63,94,0.10);
          color: #fff;
        }
        .publisher-suggestion-item.highlighted svg path,
        .publisher-suggestion-item.highlighted svg circle {
          stroke: #F43F5E;
          opacity: 1;
        }
        .publisher-suggestions-loading {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 12px 16px;
          color: #b0b0b5;
          font-size: 13px;
        }
        .suggest-spinner {
          width: 14px;
          height: 14px;
          border: 2px solid rgba(255,255,255,0.15);
          border-top-color: #F43F5E;
          border-radius: 50%;
          animation: spin 0.7s linear infinite;
          flex-shrink: 0;
        }
        .searchBtn {
          background-color: #F6255A;
          border-radius: 12px;
          padding: 12px 16px;
          height: 44px;
          color: #fff;
          font-weight: 600;
          font-size: 16px;
          line-height: 100%;
          border: none;
          cursor: pointer;
          transition: background-color 0.2s;
        }
        .searchBtn:hover:not(:disabled) {
          background-color: #e0204a;
        }
        .searchBtn:disabled {
          background-color: #9d1e42;
          cursor: not-allowed;
          opacity: 0.8;
        }
        
        .search-spinner {
          width: 16px;
          height: 16px;
          border: 2px solid #fff;
          border-top: 2px solid transparent;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        .filter-trigger{
          background: transparent;
          border: 1px solid rgba(255,255,255,0.12);
          color: #fff;
          border-radius: 12px;
          padding: 8px 12px;
          display:inline-flex;
          align-items:center;
          gap:6px;
          height:44px;
          cursor:pointer;
          font-weight:600;
        }
        .filter-trigger svg{ opacity:0.95 }
        .filter-badge{
          display:inline-flex;
          align-items:center;
          justify-content:center;
          background:#F43F5E;
          color:#fff;
          font-size:12px;
          font-weight:700;
          border-radius:999px;
          padding:2px 6px;
          margin-left:8px;
          min-width:20px;
          height:20px;
          line-height:16px;
        }

        /* Publisher Intelligence Cards */
        .publisher-intel-root {
          width: 100%;
          margin-top: 12px;
        }
        .publisher-intel-title {
          color: #fff;
          margin: 24px 0;
          font-weight: 500;
          font-size: 24px;
          line-height: 22.5px;
        }
        .publisher-intel-card {
          background: #21222D;
          border-radius: 10px;
          padding: 16px;
          flex: 1 1 240px;
          display: flex;
          align-items: flex-start;
          gap: 6px;
          box-shadow: none;
          transition: box-shadow 0.18s;
          height: 100%;
        }
        .publisher-intel-icon-wrap {
          width: 44px;
          height: 44px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 0;
        }
        .publisher-intel-card-content {
          display: flex;
          flex-direction: column;
          gap: 0;
          flex: 1;
        }
        .publisher-intel-card-label {
          color: #b3b3c6;
          font-size: 13px;
          font-weight: 500;
          margin-bottom: 2px;
          letter-spacing: 0.01em;
          text-align: right;
        }
        .publisher-intel-card-value {
          color: #fff;
          font-size: 22px;
          font-weight: 700;
          margin-bottom: 2px;
          margin-top: 0;
          letter-spacing: 0.01em;
          text-align: right;
        }
        .publisher-intel-card-change {
          font-size: 13px;
          font-weight: 600;
          margin-top: 2px;
          display: flex;
          align-items: center;
        }
        .publisher-intel-card-change-green {
          color: #4ade80;
          font-weight: 600;
          margin-right: 4px;
        }
        .publisher-intel-card-change-text {
          color: #b3b3c6;
          font-weight: 400;
        }

        /* Chips Section - Matching Screenshot */
        .chips-section {
          margin-top: 24px;
          margin-bottom: 32px;
        }
        .chips-row {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          align-items: center;
        }
        .publisher-chip {
          background: #2a2b37;
          border: 1px solid #3a3b47;
          border-radius: 20px;
          padding: 10px 16px;
          color: #b0b0b5;
          font-size: 14px;
          font-weight: 400;
          cursor: pointer;
          transition: all 0.2s ease;
          height: auto;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          white-space: nowrap;
          line-height: 1;
        }
        .publisher-chip:hover {
          background: #3a3b47;
          border-color: #4a4b57;
          color: #fff;
          transform: translateY(-1px);
        }
        .publisher-chip:active {
          background: #F43F5E;
          border-color: #F43F5E;
          color: #fff;
          transform: translateY(0);
        }
        .publisher-chip.selected {
          background: #F43F5E;
          border-color: #F43F5E;
          color: #fff;
          box-shadow: 0 0 0 2px rgba(244, 63, 94, 0.2);
        }
        .publisher-chip.selected:hover {
          background: #E11D48;
          border-color: #E11D48;
          color: #fff;
          transform: translateY(-1px);
        }
        .publisher-chip-skeleton {
          border-radius: 20px;
          background: #2a2a35;
          height: 36px;
        }

        .trending-disclaimer {
          color: rgba(255,255,255,0.7);
          font-size: 13px;
          margin-top: 2px;
          margin-bottom: 0;
        }

        /* Skeleton Loading */
        .results-skeleton {
          background: #21222D;
          border-radius: 12px;
          border: 1px solid #353748;
          padding: 20px;
        }
        .skeleton-row {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 16px 0;
          border-bottom: 1px solid #353748;
        }
        .skeleton-row:last-child {
          border-bottom: none;
        }
        .skeleton-avatar {
          width: 50px;
          height: 50px;
          background: #2a2a35;
          border-radius: 8px;
          animation: pulse 1.5s ease-in-out infinite;
        }
        .skeleton-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .skeleton-title {
          height: 16px;
          background: #2a2a35;
          border-radius: 4px;
          width: 60%;
          animation: pulse 1.5s ease-in-out infinite;
        }
        .skeleton-subtitle {
          height: 12px;
          background: #2a2a35;
          border-radius: 4px;
          width: 40%;
          animation: pulse 1.5s ease-in-out infinite;
        }
        .skeleton-stats {
          display: flex;
          gap: 12px;
        }
        .skeleton-stat {
          width: 60px;
          height: 14px;
          background: #2a2a35;
          border-radius: 4px;
          animation: pulse 1.5s ease-in-out infinite;
        }

        /* Empty State Messages */
        .no-selection-message,
        .no-results-message,
        .no-platform-data-message {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding: 60px 20px;
          border-radius: 12px;
        }
        .no-selection-icon,
        .no-results-icon,
        .no-platform-data-icon {
          margin-bottom: 20px;
          opacity: 0.7;
        }
        .no-selection-message h4,
        .no-results-message h4,
        .no-platform-data-message h4 {
          color: #fff;
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 8px;
          font-family: Rubik;
        }
        .no-selection-message p,
        .no-results-message p,
        .no-platform-data-message p {
          color: #b0b0b5;
          font-size: 16px;
          font-weight: 400;
          line-height: 1.5;
          max-width: 400px;
          margin: 0;
        }
        .platform-suggestion {
          margin-top: 16px;
          padding: 12px 20px;
          background: #2a2b37;
          border-radius: 8px;
          border-left: 3px solid #F43F5E;
        }
        .platform-suggestion p {
          color: #fff;
          font-size: 14px;
          margin: 0;
        }
        .platform-suggestion strong {
          color: #F43F5E;
        }

        /* Applied filter badges (Trending style) */
        .applied-filter-badge-trending {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 4px 8px;
          background: linear-gradient(90deg, rgba(255,154,184,0.12), rgba(246,37,90,0.12));
          color: #F6255A;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 500;
        }
        .applied-filter-badge-trending strong { color: #F6255A; font-weight: 600; }
        .applied-filter-badge-trending button { background: transparent; border: none; color: #F6255A; cursor: pointer; font-size: 12px; }

        .search-context-text {
          color: #b0b0b5;
          font-size: 14px;
          margin: 12px 0 8px 0;
        }

        /* GoToPublisherButton styles */
        .go-to-publisher-btn {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          background: linear-gradient(90deg, #4b5563 0%, #374151 100%); /* greyish gradient */
          border: 1px solid rgba(255,255,255,0.06);
          color: #fff;
          padding: 10px 18px;
          border-radius: 999px;
          font-weight: 700;
          font-size: 14px;
          cursor: pointer;
          box-shadow: 0 6px 16px rgba(0,0,0,0.35);
          transition: transform 120ms ease, box-shadow 120ms ease, opacity 120ms ease;
          position: relative;
        }
        .go-to-publisher-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 12px 24px rgba(0,0,0,0.36), 0 6px 20px rgba(255,255,255,0.02);
        }
        .go-to-publisher-btn:focus-visible {
          outline: none;
          box-shadow: 0 12px 24px rgba(0,0,0,0.36), 0 0 0 4px rgba(255,255,255,0.06);
        }
        .go-to-publisher-btn.highlight {
          animation: pulseHighlight 2.2s ease-in-out infinite;
        }
        .go-to-publisher-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }

        @keyframes pulseHighlight {
          0% { box-shadow: 0 6px 16px rgba(0,0,0,0.35), 0 0 0 0 rgba(255,255,255,0); }
          50% { box-shadow: 0 12px 28px rgba(0,0,0,0.36), 0 0 18px rgba(255,255,255,0.04); }
          100% { box-shadow: 0 6px 16px rgba(0,0,0,0.35), 0 0 0 0 rgba(255,255,255,0); }
        }
        .go-to-publisher-btn .go-icon { display: inline-block; flex: 0 0 auto; }
        .go-to-publisher-btn .go-label { display: inline-block; }
        .go-to-publisher-btn .go-loading { display: inline-block; }

        /* Publisher Intelligence header + CTA alignment */
        .publisher-intel-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          margin-top: 16px;
        }
        .publisher-intel-cta {
          display: flex;
          align-items: center;
          min-width: 220px;
          justify-content: flex-end;
        }
        @media (max-width: 768px) {
          .publisher-intel-header {
            flex-direction: column;
            align-items: stretch;
            gap: 12px;
          }
          .publisher-intel-cta {
            justify-content: flex-start;
            min-width: 0;
          }
        }

        /* Animations */
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        /* Responsive */
        @media (max-width: 768px) {
          .pageHeader {
            padding: 30px 0 16px 0;
          }
          .pageSubTitle {
            margin-bottom: 16px;
          }
          .searchField {
            width: 100%;
            min-width: 250px;
          }
          .publisher-intel-card {
            min-width: 0;
            width: 100%;
            max-width: 100%;
            min-height: 120px;
          }
          /* Ensure form wraps and all buttons are visible on mobile */
          .ca-header__content form {
            flex-wrap: wrap !important;
            gap: 8px !important;
          }
          .searchTypeSelector {
            min-width: 150px;
            flex: 0 0 auto;
          }
          .searchField {
            flex: 1 1 auto;
            min-width: 200px;
          }
          .searchBtn {
            flex: 0 0 auto;
            min-width: 80px;
          }
          .filter-trigger {
            flex: 0 0 auto;
            min-width: auto;
            white-space: nowrap;
          }
          .filter-trigger svg {
            margin-right: 4px !important;
          }
          /* Ensure filter button wrapper doesn't cause layout issues */
          .filter-button-wrapper {
            margin-left: 0 !important;
            margin-top: 0;
          }
        }
        @media (max-width: 600px) {
          .kt-header-form {
            flex-direction: column !important;
            gap: 10px !important;
          }
          .pageTitle {
            font-size: 20px !important;
          }
          /* Keep form elements in a row on mobile, allow wrapping */
          .ca-header__content form {
            flex-direction: row !important;
            flex-wrap: wrap !important;
            align-items: center !important;
            gap: 8px !important;
          }
          .searchTypeSelector {
            min-width: 140px;
            flex: 0 0 auto;
          }
          .searchField {
            flex: 1 1 auto;
            min-width: 150px;
            max-width: 100%;
          }
          .searchBtn {
            flex: 0 0 auto;
            min-width: 70px;
            padding: 12px 12px;
            font-size: 14px;
          }
          .filter-trigger {
            flex: 0 0 auto;
            min-width: auto;
            padding: 8px 10px;
            font-size: 14px;
          }
          /* Remove left margin on filter button wrapper on small screens */
          .filter-button-wrapper {
            margin-left: 0 !important;
          }
        }
        @media (max-width: 576px) {
          .chips-row {
            gap: 6px;
          }
          .publisher-chip {
            padding: 8px 12px;
            font-size: 13px;
          }
        }

       
      `}</style>
    </React.Fragment>
  )
}